import { action, observable } from 'mobx'

class FlashStore {

    @observable show: boolean = true;

    @action.bound close() {
        this.show = false
    }

    @action.bound newWindow() {
        window.open('https://jingyan.baidu.com/article/8065f87f57bc8523312498ee.html')
    }

}

export default FlashStore
